import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { Link } from 'react-router-dom'
import { useUserLang } from '../../../../contexts/LanguageSwitcherProvider'

//import styled from 'styled-components'
//import Button from '../../../Utils/Button/Button'
import './BurgerMenu.scss'
import { t } from 'i18next'

const BurgerMenu = ({items, open, setOpen}) => {

	const { lang } = useUserLang()

	const close = () => {
		setOpen(false)
	}

	return (
		<div className={'burger-menu' + (open ? ' opened' : '')}>
				<div className="mobile-bar">
					<div className="close-btn" onClick={close}>
						<LazyLoadImage width="20" height="20" src="/images/icons/icon-close.svg" alt="" />
					</div>
				</div>
				<div className="menu-wrap">
					{
						items && items.map((item, key) => {
							const toUrl = item.name==='Blog' ? item.to : (lang!=='en' ? `/${lang}` : '') + item.to
							return (
								<div key={key} className="burger-menu-item">
									{ item.label!=='Blog' && <Link key={key} to={toUrl} className="link" onClick={close}>{ t(item.label) }</Link> }
									{ item.label==='Blog' && <a key={key} href={toUrl} className="link" onClick={close}>{ t(item.label) }</a> }
								</div>
							)
						})
					}
					{/* <div className="main-menu-item">
						<AffButton colorTheme='orange' target='_blank' className='link' to='https://partners.mima.casino/'>
							{ t("Become an Affiliate") } <img width="24px" height="24px" alt={ t("Become an Affiliate") } src='/images/icons/money-white.svg' />
						</AffButton> 		
					</div> */}
					{/* <LanguageComponent /> */}
				</div>
		</div>
		
	)

}

export default BurgerMenu

/* const AffButton = styled(Button)`
	display: flex;
	justify-content: space-between;
	font-size: 1rem;
	margin-left: 1rem;
	padding: 0.5rem 0.825rem;
	height: 2.75rem;
	margin-top: 1.5rem;
	img{
		margin: 0;
		margin-left: 0.5rem;
	}
` */